import React from "react";
import styled from "react-emotion";
import color from "src/styles/color";

const Svg = styled.svg`
  &:hover {
    rect {
      fill: ${({ theme: { hoverBackground } }) => hoverBackground};
    }

    path {
      fill: ${({ theme: { hoverFill } }) => hoverFill};
    }
  }
`;

type Props = {
  fill?: string;
  background?: string;
  hoverFill?: string;
  hoverBackground?: string;
};

const Tasks = ({
  fill = color.gray5,
  background = color.white,
  hoverFill = color.gray5,
  hoverBackground = color.gray1,
}: Props) => (
  <Svg
    width="64"
    height="64"
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/Svg"
    theme={{
      hoverFill,
      hoverBackground,
    }}
  >
    <rect width="64" height="64" fill={background} />
    <path
      d="M37.7133 14.6204h-1.8094v-.8095c0-.2619-.2857-.3809-.5476-.3809h-1.4046c-.3333-.9523-1.1666-1.4285-2.1189-1.4285-.9418-.0354-1.7985.5421-2.1189 1.4285h-1.3808c-.2619 0-.5238.119-.5238.3809v.8095h-1.8094c-1.0723.0114-1.9495.8573-1.9999 1.9284v13.6418C24 31.2382 24.9523 32 25.9999 32h11.7134c1.0475 0 1.9998-.7618 1.9998-1.8094V16.5488c-.0504-1.0711-.9276-1.917-1.9998-1.9284zm-8.9517-.2381h1.3094c.2286-.0279.4122-.2018.4524-.4285.141-.614.6796-1.0548 1.3094-1.0714.6239.019 1.1545.4611 1.2856 1.0714.0427.2346.2384.4107.4762.4285h1.357v1.9046h-6.19v-1.9046zm9.9992 15.8084c0 .5237-.5237.857-1.0475.857H25.9999c-.5238 0-1.0476-.3333-1.0476-.857V16.5488c.0486-.5452.5003-.9661 1.0476-.9761h1.8093v1.2142c.0252.2668.2562.4663.5238.4524h7.0233c.2725.0149.5108-.1819.5476-.4524v-1.2142h1.8093c.5473.01.999.4309 1.0476.9761v13.6419z"
      fill={fill}
    />
    <path
      d="M30.0234 22.6436c-.1786-.1883-.4751-.1989-.6667-.0238L27.833 24.072l-.6428-.6666c-.1786-.1883-.4751-.1988-.6666-.0238-.1845.1932-.1845.4972 0 .6904l.9761 1c.0845.0946.2065.1469.3333.1428.1256-.0018.2454-.0531.3333-.1428l1.857-1.7618c.1841-.1689.1964-.4551.0274-.6391-.0086-.0096-.0178-.0188-.0273-.0275zM36.8562 23.6674h-5.4757c-.263 0-.4762.2131-.4762.4761s.2132.4762.4762.4762h5.4757c.263 0 .4762-.2132.4762-.4762s-.2132-.4761-.4762-.4761zM30.0234 18.8344c-.1786-.1883-.4751-.1989-.6667-.0238l-1.5237 1.4522-.6428-.6666c-.1786-.1883-.4751-.1989-.6666-.0238-.1845.1932-.1845.4972 0 .6904l.9761 1c.0845.0946.2065.1469.3333.1428.1256-.0018.2454-.0531.3333-.1428l1.857-1.7618c.1841-.1689.1964-.4551.0274-.6391-.0086-.0096-.0178-.0188-.0273-.0275zM36.8562 19.858h-5.4757c-.263 0-.4762.2132-.4762.4762s.2132.4761.4762.4761h5.4757c.263 0 .4762-.2131.4762-.4761s-.2132-.4762-.4762-.4762zM30.0234 26.4529c-.1786-.1883-.4751-.1988-.6667-.0238l-1.5237 1.4522-.6428-.6666c-.1786-.1882-.4751-.1988-.6666-.0238-.1845.1932-.1845.4972 0 .6904l.9761 1c.0845.0946.2065.1469.3333.1428.1256-.0017.2454-.0531.3333-.1428l1.857-1.7618c.1841-.1689.1964-.455.0274-.6391-.0086-.0096-.0178-.0187-.0273-.0275zM36.8562 27.4766h-5.4757c-.263 0-.4762.2131-.4762.4761s.2132.4762.4762.4762h5.4757c.263 0 .4762-.2132.4762-.4762s-.2132-.4761-.4762-.4761zM23.984 48h1.5v-5.71h2.07V41h-5.64v1.29h2.07V48zm5.2449-5.12c-1.38 0-2.2.81-2.26 1.82h1.24c.02-.42.33-.8.94-.8.57 0 .9.29.9.71 0 .21-.13.37-.38.37h-.85c-1.1 0-1.84.6-1.84 1.59 0 .86.67 1.51 1.65 1.51.69 0 1.25-.31 1.42-.78v.7h1.38v-3.24c0-1.14-.93-1.88-2.2-1.88zm-.25 4.19c-.39 0-.67-.23-.67-.56 0-.39.3-.65.72-.65h1.02v.07c0 .64-.39 1.14-1.07 1.14zm5.2441 1.01c1.18 0 1.96-.63 1.96-1.59 0-2.28-2.76-1.11-2.76-2.14 0-.32.27-.49.66-.49.38 0 .77.23.83.66h1.21c-.05-.99-.87-1.64-2.08-1.64-1.03 0-1.8.63-1.8 1.52 0 2.12 2.71 1.11 2.71 2.14 0 .28-.3.49-.73.49-.52 0-.87-.28-.92-.73h-1.2c.05 1.09.89 1.78 2.12 1.78zm6.2101-.08h1.68l-2.17-3.06 2.01-1.98h-1.76l-1.75 1.72v-3.91h-1.4V48h1.4v-1.58l.56-.55 1.43 2.13z"
      fill={fill}
    />
  </Svg>
);

export default Tasks;
